import SiteHeader from "@/components/feature/SiteHeader";
import HeroSection from "./components/HeroSection";
import ServicesShowcase from "./components/ServicesShowcase";
import CommunitySection from "./components/CommunitySection";
import HowItWorksSection from "./components/HowItWorksSection";
import CapabilitiesSection from "./components/CapabilitiesSection";
import MarketplaceSection from "./components/MarketplaceSection";
import DashboardSection from "./components/DashboardSection";
import PricingSection from "./components/PricingSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-sans">
      <SiteHeader />
      <HeroSection />
      <ServicesShowcase />
      <CommunitySection />
      <HowItWorksSection />
      <CapabilitiesSection />
      <MarketplaceSection />
      <DashboardSection />
      <PricingSection />
      <Footer />
    </div>
  );
}
